import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DialogService } from '@bca-core/modules/dialog/services/dialog.service';
import { DialogIdentifier, Route } from '@bca-shared/models/_enums';
import { IRootState } from '@bca-store/store.reducers';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { take, tap } from 'rxjs/operators';

@Component({
  selector: 'bca-receipt-dialog',
  template: `
    <bca-receipt
      [isDialogOpen]="true"
      [nextPageButtonText]="
        (currentRoute$ | async) < Route.COMPANY_DATA
          ? 'BUTTON.CONTINUE_DESKTOP'
          : 'BUTTON.VERIFY'
      "
      (nextPage)="nextPage.next()"
      (addProduct)="addProduct.next()"
    >
    </bca-receipt>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReceiptDialog {
  readonly nextPage = new Subject<void>();
  readonly addProduct = new Subject<void>();

  currentRoute$ = this._store$.pipe(select(({ app }) => app.currentRoute));
  Route = Route;

  constructor(private _store$: Store<IRootState>, private _dialogService: DialogService) {}

  /**
   * @description Listen to nextPage button click (only once)
   * @param closeDialog Should the dialog close after nextPage button click (default: true)
   */
  nextPage$(closeDialog: boolean = true): Observable<void> {
    return this.nextPage.asObservable().pipe(
      take(1),
      tap(() => closeDialog && this._dialogService.close(DialogIdentifier.Receipt))
    );
  }

  /**
   * @description Listen to addProduct button click (only once)
   * @param closeDialog Should the dialog close after addProduct button click (default: true)
   */
  addProduct$(closeDialog: boolean = true): Observable<void> {
    return this.addProduct.asObservable().pipe(
      take(1),
      tap(() => closeDialog && this._dialogService.close(DialogIdentifier.Receipt))
    );
  }
}
